import React from 'react'

import { propEq } from 'ramda'

import { Select, Skeleton } from '@driftt/dds'

import useLocaleOptions from 'hooks/useLocaleOptions'

interface LanguageSelectProps {
  locale: string
  updateState: (locale: string) => void
  disabled: boolean
  defaultWidgetLocale: string
}

interface LanguageOption {
  label: string
  value: string
}

const LanguageSelect = ({
  locale,
  updateState,
  disabled,
  defaultWidgetLocale,
}: LanguageSelectProps) => {
  const {
    hasMultiLanguageEnabled,
    hasDowngradedMultiLanguage,
    localeOptions,
    defaultLocaleOption,
    isLoading,
  } = useLocaleOptions(defaultWidgetLocale)
  const currentLocaleOption =
    localeOptions.find(propEq('value', locale)) || defaultLocaleOption
  const handleSelectionChange = (option: LanguageOption) => {
    updateState(option.value)
  }

  if (hasMultiLanguageEnabled || hasDowngradedMultiLanguage) {
    return (
      <Skeleton isLoading={isLoading}>
        <Select
          size={'x-large'}
          label="Meeting link page language"
          description="Language availability is set up by your admin"
          options={localeOptions}
          value={currentLocaleOption}
          isClearable={false}
          // @ts-expect-error newValue in onChange is unknown
          onChange={handleSelectionChange}
          isDisabled={disabled}
        />
      </Skeleton>
    )
  }
  return <></>
}

export default LanguageSelect
